/**
 * This file is meant to represent a way in which we can transform between different coordinate (projections).
 * Things like datum transformations would have a place in here as well.
 * @deprecated please refrain from using coordinate transformation inside the frontend space.
 */

import proj4 from 'proj4';
import { MAPBOX_LATLON_PROJECTION, UK_27700_PROJECTION } from '../constants';

/**
 * Can transform any lat,long coordinate FROM or TO the british national grid.
 * Note that this is mostly a old legacy piece of code, and that is why it only supports the british coordinate system.
 * There is no current aim to ever support any other projection.
 *
 * @param  {number[]} coordinates
 * @param  {boolean} toUK
 * @returns number[]
 */
export const transformCoordinates = (
  coordinates: number[],
  toUK: boolean
): number[] => {
  let transformed;
  if (toUK) {
    transformed = proj4(
      MAPBOX_LATLON_PROJECTION,
      UK_27700_PROJECTION,
      coordinates
    );
  } else {
    transformed = proj4(
      UK_27700_PROJECTION,
      MAPBOX_LATLON_PROJECTION,
      coordinates
    );
  }
  return transformed;
};
